var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mb-5" },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-5 mt-2",
                      attrs: {
                        label:
                          _vm.$t(
                            "apeironGwApp.generacionesSnp.form.fechaGeneracion"
                          ) + "* :",
                        "label-for": "input-fecha-generacion",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "input-fecha-generacion",
                          placeholder: _vm.$t(
                            "apeironGwApp.generacionesSnp.form.fechaGeneracion"
                          ),
                          disabled: !_vm.esEscritura,
                          state: !_vm.$v.generacion.fechaGeneracion.$invalid,
                          "date-format-options": {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                          },
                          max: _vm.fechaHoy,
                        },
                        model: {
                          value: _vm.generacion.fechaGeneracion,
                          callback: function ($$v) {
                            _vm.$set(_vm.generacion, "fechaGeneracion", $$v)
                          },
                          expression: "generacion.fechaGeneracion",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        {
                          attrs: {
                            state: !_vm.$v.generacion.fechaGeneracion.$invalid,
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [_c("b-col", { staticClass: "mt-5" }, [_c("hr")])],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticStyle: { "text-align": "end" } },
                [
                  _vm.esEscritura
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            type: "button",
                            variant: "primary",
                            disabled: _vm.formularioIsInvalid,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.guardarGeneracion()
                            },
                          },
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.generacionesSnp.acciones.guardar"
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-2",
                            attrs: { icon: "save" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "button",
                        variant: "secondary",
                        disabled: !_vm.esEscritura,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.limpiarDatos()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.generacionesSnp.acciones.reset"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "mr-2",
                        attrs: { icon: "refresh" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }